<template>
  <div class="plan">
    <el-timeline>
      <el-timeline-item
        v-for="(activity, index) in activityPlan"
        :key="index"
        color="#3056D9"
        :timestamp="activity.dateInfo"
        placement="top">
        {{ activity.detailInfo }}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  name: 'plan',
  props: { activityPlan: Array },
  components: {},
  data () {
    return {
      reverse: true
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
.plan {
  box-sizing: border-box;
  padding: 40px 30px 0;
}
/deep/.el-timeline-item__tail{
    border-left: 2px solid #3056D9;
}
/deep/.el-timeline-item{
    padding-bottom: 35px;
}
/deep/.el-timeline-item__wrapper{
    display: flex;
}
/deep/.el-timeline-item__timestamp{
    font-size: 16px;
    font-weight: bold;
    // line-height: 18px;
    line-height: 1.5;
    margin-top: -3px;
    color: #000;
    vertical-align: middle;
}
/deep/.el-timeline-item__content{
    margin-left: 20px;
    font-size: 16px;
    font-family:"Microsoft Yahei";
    color: #000;
}
</style>
